module.exports = __webpack_public_path__ + "img/settings_icon_pink.2a0475c1.svg";